module.exports = __webpack_public_path__ + "07177779299afd32531fde27c73944e4.pdf";